import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "five-stars" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_icon = _resolveComponent("f-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
      return _createElementVNode("span", {
        key: i,
        class: "five-stars__star",
        style: _normalizeStyle({ marginRight: i === 5 ? 0 : `${_ctx.spacing}px` })
      }, [
        _createVNode(_component_f_icon, {
          name: i <= _ctx.scoreInt ? 'star-fill' : 'star',
          size: _ctx.size,
          onClick: ($event: any) => (_ctx.handleClickStar(i))
        }, null, 8, ["name", "size", "onClick"]),
        (i === _ctx.scoreInt && _ctx.hint && _ctx.hint[i - 1])
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              style: _normalizeStyle({
          fontSize: `${_ctx.size / 2}px`,
          lineHeight: `${_ctx.size / 2}px`,
          top: `${_ctx.size + _ctx.spacing}px`,
          left: `${_ctx.size / 2}px`,
        }),
              class: "five-stars__hint"
            }, _toDisplayString(_ctx.hint[i - 1]), 5))
          : _createCommentVNode("", true)
      ], 4)
    }), 64))
  ]))
}